module.exports = __webpack_public_path__ + "static/media/slide2Active.ff497104.png";